module.exports = __webpack_public_path__ + "static/media/confetti_mobile_left.d25223c1.png";